import { render } from "./UserAccountRegisterView.vue?vue&type=template&id=659172fb&scoped=true"
import script from "./UserAccountRegisterView.vue?vue&type=script&lang=js"
export * from "./UserAccountRegisterView.vue?vue&type=script&lang=js"

import "./UserAccountRegisterView.vue?vue&type=style&index=0&id=659172fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659172fb"]])

export default __exports__